import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function CtaSection() {
  return <section id="cta" className="py-32 relative overflow-hidden" data-id="element-36">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-cerebro-orange/20 rounded-full blur-[120px] -z-10" data-id="element-37" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="glass-card p-12 md:p-20 border-cerebro-orange/30 shadow-[0_0_50px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-39">
          {/* Inner subtle glow */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cerebro-orange to-transparent opacity-50" data-id="element-40"></div>

          <div className="flex justify-center mb-8" data-id="element-41">
            <div className="p-4 rounded-full bg-cerebro-orange/20 text-cerebro-orange" data-id="element-42">
              <Zap className="w-10 h-10" data-id="element-43" />
            </div>
          </div>

          <h2 className="text-4xl md:text-6xl font-display font-bold text-white mb-8 leading-tight" data-id="element-44">
            Empieza hoy a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cerebro-orange to-yellow-400" data-id="element-45">
              entrenar tu mente
            </span>
          </h2>

          <motion.a href="https://ideas-que-transforman-2.myshopify.com/products/metodo-m3-para-mejorar-la-memoria" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-white transition-all duration-300 bg-cerebro-orange rounded-full shadow-[0_0_30px_rgba(249,115,22,0.6)] hover:shadow-[0_0_50px_rgba(249,115,22,0.8)] w-full sm:w-auto" data-id="element-46">
            Descargar ebook ahora
          </motion.a>

          <p className="mt-6 text-slate-400 text-sm" data-id="element-47">
            Acceso inmediato • Pago 100% seguro
          </p>
        </motion.div>
      </div>
    </section>;
}